import find from 'lodash/find';
import forIn from 'lodash/forIn';
import { mapState } from 'vuex';

import { i18n } from '@/i18n';

export default {
  data() {
    return {
      shakeErrors: false,
    };
  },

  methods: {
    removeShake() {
      // eslint-disable-next-line no-return-assign
      setTimeout(() => this.shakeErrors = false, 800);
    },

    showError(error, toastServerErrors = false) {
      const errorMessage = this.parseError(error, toastServerErrors);

      if (errorMessage) {
        this.displayError(errorMessage);
      }
    },

    displayError(error) {
      this.$toast(error, {
        status: 'error',
        timeout: 8000,
      });
    },

    shouldShake(input, localError) {
      return this.shakeErrors && this.hasError(input, localError);
    },

    hasError(input, localError) {
      const error = find(this.errorBag, { field: input });

      return !!(error || localError);
    },

    getErrorMessage(input, localError, localErrorMessage) {
      const error = find(this.errorBag, { field: input });
      if (error) {
        return error.message;
      }
      if (localError) {
        return localErrorMessage;
      }

      return null;
    },

    clearErrors() {
      this.$store.commit('errors/clear');
    },

    parseError(error, toastServerErrors = false) {
      this.clearErrors();

      if (error.response?.data?.status === 'fail') {
        const that = this;
        forIn(error.response.data.data, (item, key) => {
          that.$store.commit('errors/add', {
            field: key,
            message: item.join(' ').trim(),
          });

          if (toastServerErrors) {
            this.displayError(item.join(' ').trim());
          }
        });

        this.shakeErrors = true;
        this.removeShake();

        return null;
      }

      if (error.response?.data?.message) {
        return this.displayError(error.response.data.message);
      }

      if (!error.code && typeof error.message !== 'undefined') {
        // TODO: Need to log / report these so we can catch them and localize them
        return this.displayError(error.message);
      }

      if (typeof (error.message) !== 'undefined') {
        // TODO: Need to log / report these so we can catch them and localize them
        return this.displayError(`${i18n.t('errors.uncaught-error')}: ${error.message}`);
      }

      return this.displayError(i18n.t('errors.there-was-an-error-processing-your-request'));
    },

    hasValidInputs(inputs, ctx = null) {
      const context = ctx || this;

      context.clearErrors();

      inputs.$reset();
      inputs.$touch();

      if (inputs.$invalid) {
        context.shakeErrors = true;
        context.removeShake();

        return false;
      }

      return true;
    },
  },

  computed: {
    ...mapState('errors', ['errorBag']),
  },
};
